<template lang='pug'>
  v-card
    //- Qr dialog
    v-dialog(persistent v-if="isPrinting && model.qrcode" :value='isPrinting'  max-width='800px' :fullscreen='isMobile' transition="dialog-bottom-transition")
      print-qr-code(@endPrint="isPrinting = false" :image="model.qrcode")
    //- Content
    v-card-title.dialog-card-title
      p Detalles del Producto
      v-icon(color="white" aria-label="Close" @click="$emit('close')") mdi-close
    v-card-text.body-1.text-center
      v-row
        v-col(cols="12")
          v-container
            v-row
              v-col(cols='5')
                .product--detail__margin
                  .product--detail__product--name.limit-text {{ model.name | shortName }}
                v-row
                  .product--detail__info Nombre del producto
                v-row.justify-center(v-if="model.qrcode")
                  v-col(cols="6")
                    // p Codigo Qr
                    v-img(:src="model.qrcode" style="max-width: 180px; margin: auto;")
                    v-btn(small rounded color="#008e95" @click="print()").product--detail__product--img__btn.d-flex Imprimir
                v-row(v-else)
                  v-col(style="min-height: 126px; align-items: center; display: flex; justify-content: center;")
                    v-btn(color="#008e95" rounded small :loading="loadingqr" @click="generateQrCode()" style="padding: 10px !important;") Generar codigo QR
              v-col(cols='7')
                v-row.product--detail__product--img.py-0
                  input.d-none(ref="file" type="file" @change="handleImageUpload" accept="image/*")
                  v-col(v-if="showOptions" cols="12").text-right.py-0
                    v-icon(color="green" @click="$emit('edit')").px-2 mdi-pencil
                    v-icon(color="red" @click="$emit('delete')") mdi-delete
                  v-card( v-if='model.pictures.imageInput1 !== ""' column xs12).mt-4.text-xs-center.product--detail__product--img__img
                    img( :src="model.pictures.imageInput1"  style="max-height: 200px; object-fit:contain;")
                  v-layout(v-else="" column xs12)
                    p.text-center sin imagen
                    v-card.pa-1.mx-auto.mt-0.d-inline-flex.v-card--account(class='grey--text' outlined="" height="150" width="150")
                      v-icon.mx-auto(size="96")
                        | mdi-close
                v-row.py-0
                  v-btn(small color="#008e95" :loading="imageLoading" :disabled="imageLoading" rounded @click="$refs.file.click()").product--detail__product--img__btn Subir Imagen
        v-col(cols="12")
            v-tabs()
              v-tab Datos
              v-tab Historial
              v-tab-item
                v-card(flat='').pa-2
                  v-layout.column
                    v-flex.mt-4.column
                      v-flex.purchase-form__input(style='display:flex; ' v-for="(item, index) in model.location" :key="index" )
                        v-col(cols="6")
                          v-row.product--detail__margin
                            span.product--detail__info--name(:style="item.showLowStockAlert ? 'border-left: 10px solid rgb(255, 161, 91)' : ''") {{item.name}}
                          v-row
                            span.product--detail__info Tienda Nombre
                        v-col(cols="3" v-if="model.type !== 'ingredient'")
                          v-row.product--detail__margin
                            span.ml-3.product--detail__info--name.product--detail__info--name__border {{item.price | numberFormat}}
                          v-row
                            span.product--detail__info Precio de venta
                        v-col(cols="3" v-if='model.type==="product" || model.type==="ingredient" || !model.type')
                          v-row.product--detail__margin.justify-end
                            span.product--detail__info--name.product--detail__info--name__border {{getProductStock(item)}}
                          v-row.justify-end
                            span.product--detail__info Cantidad
                        v-col(cols="3" v-if='model.type === "bundle"')
                          v-row.product--detail__margin.justify-end
                            span.product--detail__info--name.product--detail__info--name__border {{getStock(item)}}
                          v-row.justify-end
                            span.product--detail__info Cantidad
                      v-flex
                        v-col(cols="6").mt-4
                          v-row.product--detail__margin
                            span.product--detail__info--name(v-if='model.type !== "bundle"') {{model.price.buy | numberFormat}}
                            span.product--detail__info--name(v-else) {{getBundleCost | numberFormat}}
                          v-row
                            span.product--detail__info $ Compra
                          v-row.product--detail__product--img

                          v-row.product--detail__margin(v-if="model.type !== 'ingredient'")
                            span.product--detail__info--name(v-if='model.price') {{model.price.sale | numberFormat}}
                          v-row(v-if="model.type !== 'ingredient'")
                            span.product--detail__info $ Venta
                        v-col(cols="6")
                          v-row(v-if="model.type !== 'ingredient'")
                            v-combobox(disabled v-model="model.taxesLstProduct" :items='model.taxesLstProduct' item-text="data.name" hide-selected='' label='Impuestos' multiple='' small-chips='')
                              v-list-item
                                v-list-item-content
                                  v-list-item-title
                                    | No hay resultados encontrados similares.
              v-tab-item
                v-card(flat='')
                  product-log(:item='model')
      v-row(v-if="model.type ==='bundle'")
        v-col(cols="12")
          v-row(style="font-size: 1.5rem;").justify-start.mb-4
            span.text-start
              b Margen:
            span.ml-4.text-start
              b $ {{utility }}
            span.ml-4.text-start
              b(:style="utilityPercentage < 0 ? 'color:red' :'color:green' ") ( {{utilityPercentage}}% )
          v-row.ingredient__bar.mb-4
            h4.py-3.pl-6 Ingredientes
          v-row
            v-flex.purchase-form__input(style='display:flex; ' v-for="(ingredient, index) in model.ingredients" :key="index" )
              v-text-field( readonly label='Nombre del producto'  type="text", v-model='ingredient.name')
              v-text-field( readonly label='Cantidad'  type="text", v-model='ingredient.amount')
              v-text-field( readonly  label='Costo unitario'  type="text", v-model='ingredient.purchase' prefix ='$' )
              v-text-field( readonly label='Total'  type="text", :value='ingredient.purchase * ingredient.amount' prefix ='$')
</template>
<script>
  import ProductLog from '../logs/ProductLog'
  import * as firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  import QRious from 'qrious'
  import PrintQrCode from '@/components/custom/PrintQrCode'
  export default {
    components: {
      ProductLog,
      PrintQrCode,
    },
    filters: {
      shortName (val) {
        if (val.length > 50) {
          return val.substring(0, 50) + '...'
        } else {
          return val
        }
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    props: {
      model: Object,
      sample: Boolean,
      field: Object,
      context: String,
      showOptions: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        valueType: 'leasing',
        slider: 10,
        imageRef: '',
        e1: 0,
        show: false,
        isMobile: false,
        imageLoading: false,
        audioLoading: false,
        toggle_exclusive: 2,
        loadingqr: false,
        isPrinting: false,
      }
    },
    computed: {
      getBundleCost () {
        const vm = this
        // let stock = 0;
        let result = 0
        vm.model.ingredients.forEach(function (el) {
          const element = vm.inventory.find(item => item.id === el.id)
          // console.log(element)
          if (element) {
            result += +element.price.buy * +el.amount
          } else {
            if (el.purchase) result += +el.purchase * +el.amount
          }
        })
        return result
      },
      utilityPercentage () {
        const margin = ((this.model.price.salewithouttax - this.model.price.buy) / this.model.price.sale * 100).toFixed(2) || 0
        return margin
      },
      utility () {
        const value = this.model.price.salewithouttax - this.model.price.buy || 0
        return value
      },
      inventory () {
        const vm = this
        if (vm.model.type === 'bundle') {
          return this.$store.getters['products/getAllItems']
        }
        return {}
      },
      sliderValue () {
        return this.slider
      },
      user () {
        return this.$store.state.users.user
      },
    },
    mounted () {
      const vm = this
      // console.log(vm.model)
      if (!vm.model.qrcode) {
        vm.model.qrcode = false
      }
    },
    methods: {
      getProductStock (item) {
        const vm = this
        if (vm.model.magnitude) {
          return item.stock + ' ' + vm.model.unit
        } else {
          return item.stock
        }
      },
      getStock (location) {
        const vm = this
        // let stock = 0;
        const ingredients = vm.model.ingredients
        const quantities = []

        ingredients.forEach(function (el) {
          const currentItem = vm.inventory.find(item => item.id === el.id)
          if (currentItem) {
            try {
              if (currentItem.location[location.id]) { quantities.push(Math.floor(currentItem.location[location.id].stock / el.amount)) } else quantities.push(0)
            } catch (err) {
              quantities.push(0)
            }
          } else quantities.push(0)
        })

        return Math.min(...quantities) || 0
      },
      getCost (el) {
        const vm = this
        // let stock = 0;
        const element = vm.inventory.find(item => item.id === el.id)
        if (element) {
          return element.price.buy
        } else {
          return el.purchase
        }
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        const metadata = {
          contentType: file.type,

          customMetadata: {
            targetType: file.type,
            targetId: vm.model.id,
            targetName: vm.model.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        let userId
        if (vm.user.adminUid) {
          userId = vm.user.adminUid
        } else {
          userId = vm.user.uid
        }
        storageRef.child(`users/${userId}/inventory/pictures/${vm.model.id}/imageInput1`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.pictures.imageInput1 = url
            // console.log(vm.model.pictures.imageInput1, 'imageinput')
            vm.imageLoading = false
          })
        }).catch(function (error) {
          vm.imageLoading = false
          console.error('Upload failed:', error)
        })
      },
      async handleImageUpload (event) {
        const vm = this
        vm.imageLoading = true
        const imageFile = event.target.files[0]
        // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

        const options = {
          maxSizeMB: 0.06,
          maxWidthOrHeight: 200,
          useWebWorker: true,
          maxIteration: 14,
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
          // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
          if (imageFile.size > compressedFile.size) {
            // console.log('compressed is smaller')
            await vm.uploadToServer(compressedFile)
          } else {
            // console.log('original is smaller')
            await vm.uploadToServer(imageFile)
          } // if original is smaller
        } catch (error) {
          vm.imageLoading = false
          // console.log(error)
        }
      },
      generateQrCode () {
        const vm = this
        vm.loadingqr = true
        const qr = new QRious({
          element: document.getElementById('qrcode'),
          value: 'Tender',
        })
        qr.set({
          value: vm.model.id,
          size: 300,
          padding: 25,
        })
        vm.model.qrcode = qr.toDataURL()
        vm.$store.dispatch('products/updateItem', { payload: vm.model, message: ['Se genero el codigo QR de ' + vm.model.name] }).then(() => {
          vm.loadingqr = false
        })
      },
      print () {
        /* const vm = this
        const win = window.open('about:blank', '_new')
        win.document.open()
        win.document.write([
          '<html>',
          '   <head>',
          '   </head>',
          '   <body onload="window.print()" onafterprint="window.close()" onbeforeunload ="">',
          '       <img src="' + vm.model.qrcode + '"/>',
          '   </body>',
          '</html>',
        ].join(''))
        win.document.close() */
        /* const vm = this
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write([
          '<html>',
          '   <head>',
          '   </head>',
          '   <body onload="window.print()" onafterprint="window.close()" onbeforeunload ="">',
          '       <img src="' + vm.model.qrcode + '"/>',
          '   </body>',
          '</html>',
        ].join(''))
        WinPrint.document.close()
        WinPrint.setTimeout(function () {
          WinPrint.focus()
          WinPrint.print()
          WinPrint.close()
        }, 500) */
        const vm = this
        vm.isPrinting = true
      },
    },

  }
</script>
<style scoped lang="scss">
  $break-large: 1200px;
  $primary-color: #c29f52;
  .limit-text{
    max-width: 200px;
  }
  .grid-picker{
    text-align: center;
    min-width: 100%;
    display: grid;
    position: relative;
    flex: 1;
    width: 100%;
    grid-template-areas:

      'picture picture '
      'title title '
      'button button';
    @media screen and (min-width: $break-large) {
      grid-template-areas:

        'title picture picture '
        'title picture picture '
        'button button button';
      .image-slot{
        min-width: 400px;
        height: 250px;
        overflow: hidden;
      }
    }

    grid-gap: 10px;

    padding: 10px;
    .picker-btn{

      grid-area: button;
      flex: 1;
      height: 50px;
    }
    .image-slot{
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      display: flex;
      grid-area: picture;
      max-width: 350px;
      max-height: 250px;
      background: #9e9e9e;
      align-items:center;
      justify-content: center;

    }
  }

  .phone-screen{

    background: url("/img/phone.png");
    display:flex;
    flex-direction: column;
    border-radius: 50px;
    border: 1px solid black;

    min-width: 379px;
    min-height: 736px;
    background-size:  379px 736px;
    background-repeat: no-repeat;
    margin:auto;
    overflow: hidden;
    &__content{

      overflow-y: auto;
      max-width: 382px;
      max-height: 595px;
      margin: auto !important;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      padding: 0 15px;
    }
  }
  .main-carousel{
    position: relative;
    &__overlay{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      height: 45px;
      width: 100%;
      margin: auto !important;
      background:rgba(#000,0.5);
      color: #fff;
      text-align: center;

    }
  }
  .property-values{
    border: 1px solid #c29f52;
    border-radius: 30px;
    height: auto;
    padding: 0 10px;
    h3{
      color:#c29f52;
      font-weight: 900;

    }
    .price-tooltip{
      color:#c29f52;
      font-weight: bold;
      margin:auto;
      margin-top:-10px;
      max-width: 100px;
      border: 1px solid #c29f52;
      border-radius: 15px;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
      border-top: none;
    }
  }
  .numPayments{
    background: white !important;
    border: 1px solid #777;
    border-radius: 25px;
    width:auto;
    max-width: fit-content;

    &__button{
      color:#000 !important;
      border-radius: 40px;
    }
  }
  .v-input--slider{
    margin-top:0;
  }
  .v-tabs__container{
    max-width: 100%;
    overflow-x: auto;

  }
  .property-sections{
    span,b{
      font-size: 15px !important;
    }

    .v-tab{
      color: black !important;
    }
  }
  .property-toolbar{

  }

  .product--detail {
      &__title {
        background: rgb(45,180,188);
        background: linear-gradient(90deg, rgba(45,180,188,1) 0%, rgba(87,101,190,1) 100%);
        color: white;
        font-weight: 800;
        border-radius: 5px;
        text-transform: uppercase;
      }

      &__product--name {
        max-width: '100%';
        padding-top: 3rem;
        padding-bottom: 6px;
        font-weight: 500;
        text-transform: uppercase;
        font-weight: 800;
        font-size: 1.7rem;
        color: #30b4bb;
        display: inline-block;

        @media (max-width: 600px) {
          font-size: 1.3rem;
        }
      }

      &__info--name {
        font-weight: 500;
        font-weight: 800;
        font-size: 1.6rem;
        padding-bottom: 8px;
        color: #696969;
        display: inline-block;

        &__border {
          padding-bottom: 0px !important;
          border: 2.5px #c9c9c9 solid;
          border-radius: 5px;
          font-size: 1.2rem;
          margin-bottom: 3px;
        }
      }

      &__product--img {
        padding-top: 2rem;
        border-radius: 30px;
        &__img {
          left: 50%;
          transform: translate(-50%, 0);
          max-width: 150px;
        }

        &__btn {
          top: 1rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }

      &__margin {
        border-bottom: 1px solid #e6e6e6;
      }

      &__info {
        padding-top: 6px;
        font-weight: 100;
        font-size: 0.9rem;
        //color: #525252;
        color: #939393;
        display: inline-block;
      }

      &-product__card {
        height: 403;
        width: 302;
        margin-bottom: 24px;
        padding: 12px;
        display: inline-block;
        border-width: 4px;
        border-radius: 25px;
      }
    }
    .ingredient {
      &__bar {
        background: hsl(227deg 45% 54%);
        color: white;
        font-size: 1.3rem;
        font-weight: 600;
        align-content: center;
      }
    }
</style>
